import { Redirect } from "react-router-dom";
import {
  accessDenied,
  accessFailed,
  activatingAccount,
  activatingLicense,
  choosePassword,
  createWorkspace,
} from "./index";
import { useSelector } from "react-redux";
import { SubscriptionStatus } from "../../tools/cp-middleware-adapter";
import {
  automaticLicenseFlow,
  checkpointLicenseExpiredCode,
  checkpointLicenseInvalidCode,
} from "@p81-common/shell-core-js";
import { ROOT } from "../paths";
import paths from "routes/organization/organizationPaths";

export interface Props {
  isCPAccessDenied: boolean;
  isCpDemoTenant: boolean;
  hasCPWriteAccess: boolean;
  subscriptionStatus: SubscriptionStatus;
}

export const RedirectByTenantState = (props: Props) => {
  const {
    isCPAccessDenied,
    hasCPWriteAccess,
    isCpDemoTenant,
    subscriptionStatus,
  } = props;

  const { userData } = useSelector((s: any) => s.cpCheckTenantGet);
  const {
    tenantExists,
    userExists,
    checkpointLicenseErrors,
    manuallyActivatingLicense,
    isCreatingNewWorkspace,
    hasAccess,
  } = userData || {};

  const cpAccessDeniedAndNotDemoTenant = !isCpDemoTenant && isCPAccessDenied;
  const noData = !userData;
  const noTenant = !tenantExists;
  const tenantWithoutUser = tenantExists && !userExists;

  if (!hasAccess || cpAccessDeniedAndNotDemoTenant) {
    return <Redirect to={accessDenied} />;
  }

  if (
    noData ||
    (noTenant && !hasCPWriteAccess) ||
    (automaticLicenseFlow &&
      (checkpointLicenseErrors === checkpointLicenseExpiredCode ||
        subscriptionStatus === SubscriptionStatus.FAIL))
  ) {
    return <Redirect to={accessFailed} />;
  }

  if (noTenant) {
    return <Redirect to={createWorkspace} />;
  }

  if (tenantWithoutUser) {
    return <Redirect to={choosePassword} />;
  }

  if (isCreatingNewWorkspace) {
    return <Redirect to={activatingAccount} />;
  }

  if (
    checkpointLicenseErrors === checkpointLicenseInvalidCode &&
    manuallyActivatingLicense
  ) {
    return <Redirect to={activatingLicense} />;
  }

  return <Redirect to={paths(ROOT).DASHBOARD} />;
};
